import { render, staticRenderFns } from "./PaySuccessFor5k.vue?vue&type=template&id=411270ed&"
import script from "./PaySuccessFor5k.vue?vue&type=script&lang=js&"
export * from "./PaySuccessFor5k.vue?vue&type=script&lang=js&"
import style0 from "./PaySuccessFor5k.vue?vue&type=style&index=0&class=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports